export enum StatsElementInfoBlock {
  Root = 'StatsElementInfo',
}

export enum StatsElementInfoModifier {
  Description = 'description',
  FootNote = 'footNote',
}
